<template>
    <sidebar-tab title="Moderators" icon="users-crown" :card_on_mobile="true" on_tab="main">
        <div class="tw-flex tw-flex-col" v-if="moderators_loaded">
            <template v-if="activeModerators.length > 0">
                <div class="tw-flex tw-items-center md:tw-mb-4" v-for="moderator in activeModerators">
                    <user-avatar class="tw-mr-4" :avatar="moderator.user.avatar"></user-avatar>
                    <a :href="'/profile/' + moderator.user.username" class="tw-flex-1 tw-break-all tw-font-semibold hover:tw-underline">
                        {{ moderator.user.username }}
                        <template v-if="moderator.role === 'founder'">
                            <span class="light-text tw-text-sm tw-pl-1">({{ $t('groups.group_founder') }})</span>
                        </template>
                    </a>
                </div>
            </template>
            <template v-else>
                <p class="tw-mb-2 tw-text-sm">{{ $t('groups.no_moderator_message') }}.</p>
            </template>
        </div>
    </sidebar-tab>
</template>

<script>
    import axios from 'axios';
    import Global from '../../../mixins/Global';

    let _ = require('lodash');

    export default {
        name: 'SidebarModerators',

        mixins: [Global],

        props: {
            model_id: {
                required: true,
            },
            endpoint_name: {
                required: true,
            },
        },

        data() {
            return {
                moderators: [],
                moderators_loaded: false,
            };
        },

        computed: {
            activeModerators() {
                return _.orderBy(this.moderators.filter(moderator => (moderator.user !== null)), 'role', 'asc');
            },
        },

        methods: {
            getModerators() {
                axios.get(`/api/v3/${this.endpoint_name}/${this.model_id}/moderators?size=4`).then((users) => {
                    this.moderators = users.data.data;
                    this.moderators_loaded = true;
                });
            },
        },

        mounted() {
            this.getModerators();
        },
    };
</script>
